import { render, staticRenderFns } from "./cModalEliminar.vue?vue&type=template&id=0bc83cf9"
import script from "./cModalEliminar.vue?vue&type=script&lang=js"
export * from "./cModalEliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports